import SwipeDrawer from "common/Gustures/SwipeDrawer.tsx";
import React, { PropsWithChildren, useContext, useMemo, useRef } from "react";
import FiltersColumn from "common/Filters/FiltersColumn/FiltersColumn.tsx";
import { PageWrapperContext } from "common/Home/PageWrapper.context.tsx";
import { SwipeFiltersContext } from "common/Filters/common/SwipeFilters.context.ts";

const SwipeFilters = ({ children }: PropsWithChildren) => {
  const { filters } = useContext(PageWrapperContext);
  const swipeActiveRef = useRef(false);

  const filtersColumn = filters ? (
    <FiltersColumn
      filtersActions={filters?.actions}
      filtersSelectors={filters?.selectors}
      filterTypeToTitle={filters?.filterTypeToTitle}
      hideFilterTypes={filters?.hideFilterTypes}
      isLoading={filters.loading}
    />
  ) : undefined;

  const contextValue = useMemo(
    () => ({
      swipeActiveRef,
    }),
    []
  );

  return (
    <SwipeFiltersContext.Provider value={contextValue}>
      <SwipeDrawer content={filtersColumn}>{children}</SwipeDrawer>
    </SwipeFiltersContext.Provider>
  );
};

export default SwipeFilters;
